import Container from "./Container";
import Navbar from "./Navbar";
import SocialIcons from "./SocialIcons";


const Footer = () => {
    return (
        <div className="bg-primary py-2 drop-shadow-2xl">
            <Container classes={"flex items-center justify-center md:justify-between"}>
                <div className="hidden md:block">
                    <Navbar />
                </div>
                <div className="flex items-center space-x-2 text-light-silver">
                    <h3 className="text-base">©</h3>
                    <div>
                        <h3 className="text-sm">All rights Reserved</h3>
                        <a href="https://mayonity.com/" target="blank">
                        <h4 className="text-[10px]">Developed by <span className="text-white">Mayonity</span></h4>
                        </a>
                    </div>
                </div>
                <div className="hidden md:block">
                    <SocialIcons />
                </div>
            </Container>
        </div>
    );
};

export default Footer;